import React from 'react';
import PropTypes from 'prop-types';

import IconSettingsV2 from '../svg/IconSettingsV2';

function ButtonSettings({ className, style }) {
  const open = () => {
    if (window.settings_panel_show) {
      window.settings_panel_show();
    }
  }
  return (
    <div onClick={open}>
      <IconSettingsV2 id={`menu_settings`} className={`${className}`} style={style} />
    </div>
  )
}

ButtonSettings.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
}

export default ButtonSettings;
